import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Common } from '../../utils/common';
import DataTable from '../reporting_utils/DataTable';

function StaticCampaignsTable({ tableData }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <div
        className='active_campaigns_table_header'
        role='button'
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className={isOpen ? 'fa fa-caret-down' : 'fa fa-caret-right'} /> Static Campaigns
      </div>
      <div hidden={!isOpen}>
        <DataTable
          columnDefs={buildColumns()}
          data={tableData}
          title='Static Campaigns'
          showTotalFooter={true}
           order={[[7, 'desc']]}
        />
      </div>
    </>
  );
}

function buildColumns() {
  const columns = [];
  columns.push({ data: 'location_name', className: ' ', title: 'Location Name' });
  columns.push({ data: 'domain_name', visible: false, title: 'Domain Name' });
  columns.push({
    data: 'campaign_name',
    className: ' ',
    title: 'Campaign Name',
    aggregation: 'count',
  });
  columns.push({
    data: 'dids',
    className: 'text-center whitespace_nowrap',
    render(data, type) {
      if (data) {
        if (type === 'filter') {
          return `${data} ${Common.formatPhoneNumber(data)}`;
        } else {
          return Common.formatPhoneNumber(data);
        }
      } else {
        return null;
      }
    },
    title: 'DID Number',
  });
  columns.push({
    data: 'created_at',
    title: 'Created',
    className: 'text-center whitespace_nowrap',
    render: (data) => (data ? moment.utc(data).local().format('MMM D, YYYY hh:mm:ss A') : null),
  });
  columns.push({
    data: 'ended_at',
    title: 'Ended',
    className: 'text-center whitespace_nowrap',
    render: (data) => (data ? moment.utc(data).local().format('MMM D, YYYY hh:mm:ss A') : null),
  });
  columns.push({
    data: 'status',
    title: 'Status',
    render: (data) => {
      if (data === 1) {
        return 'Active';
      }
      if (data === 2) {
        return 'Paused';
      }
      if (data === 3) {
        return 'Ended';
      } else {
        return null;
      }
    },
  });
  columns.push({
    data: 'number_of_calls',
    title: 'Number of Calls',
    render: $.fn.dataTable.render.number(','),
    aggregation: 'sum',
  });
  columns.push({
    data: 'leadscore_calls',
    title: 'Processed Calls',
    render: (data) => (data ? data : 0),
    aggregation: 'sum',
  });
  columns.push({
    data: 'transcribed_calls',
    title: 'Transcribed Calls',
    render: (data) => (data ? data : 0),
    aggregation: 'sum',
  });
  columns.push({
    data: 'redacted_calls',
    title: 'Redacted Calls',
    render: (data) => (data ? data : 0),
    aggregation: 'sum',
  });
  columns.push({
    data: 'duration',
    title: 'Duration',
    render(data) {
      return momentDurationToTime(moment.duration(Number(data), 'seconds'));
    },
    aggregation: 'duration',
  });
  columns.push({
    data: 'texted_enabled',
    title: 'Texting Enabled',
    render: (data, type) => {
      if (type === 'sort') {
        return data === 0;
      } else if (type === 'export') {
        return data === 0 ? 'No' : 'Yes';
      } else {
        var className = data == 0 ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok';
        return `<i class='${className}'></i>`;
      }
    },
    aggregation: 'sum',
  });
  columns.push({
    data: 'number_of_sms_messages',
    title: 'SMS Count',
    render: $.fn.dataTable.render.number(','),
    aggregation: 'sum',
  });

  return columns;
}

function momentDurationToTime(dur) {
  var hours = Math.floor(dur.asHours());
  var mins = Math.floor(dur.asMinutes()) - hours * 60;
  var sec = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;

  return (
    (hours > 9 ? hours : '0' + hours) +
    ':' +
    (mins > 9 ? mins : '0' + mins) +
    ':' +
    (sec > 9 ? sec : '0' + sec)
  );
}

StaticCampaignsTable.propTypes = {
  tableData: PropTypes.array.isRequired,
};

export default StaticCampaignsTable;
